export function isBeyondChristmasSeason() {
  const currentDate = new Date();
  const afterChristmas = new Date(currentDate.getFullYear(), 0, 10); // Jan 10,
  const beforeChristmasStart = new Date(currentDate.getFullYear(), 6, 1); // July 1

  return currentDate > afterChristmas && currentDate < beforeChristmasStart;
}
